import { FC, memo } from 'react';
import dayjs from 'dayjs';
import { Feedback } from 'entities/feedback';
import styles from './FeedbackInfoSection.module.scss';

interface FeedbackInfoSectionProps {
  feedback: Feedback;
}

export const FeedbackInfoSection: FC<FeedbackInfoSectionProps> = memo(({
  feedback,
}) => {
  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return 'Не указано';
    return dayjs(dateString).format('DD.MM.YYYY HH:mm');
  };

  return (
    <div className={styles.infoSection}>

      <div className={styles.infoItem}>
        <span className={styles.label}>Тема обращения:</span>
        <span className={styles.value}>{feedback.subject || 'Не указана'}</span>
      </div>

      <div className={styles.infoItem}>
        <span className={styles.label}>Текст обращения:</span>
        <div className={styles.textBox}>
          {feedback.text || 'Не указан'}
        </div>
      </div>

      <div className={styles.infoItem}>
        <span className={styles.label}>Фамилия и Имя:</span>
        <span className={styles.value}>{feedback.ownerName || 'Не указано'}</span>
      </div>

      <div className={styles.infoItem}>
        <span className={styles.label}>Компания:</span>
        <span className={styles.value}>{feedback.company || 'Не указана'}</span>
      </div>
      <div className={styles.infoItem}>
        <span className={styles.label}>Дата создания:</span>
        <span className={styles.value}>{formatDate(feedback.createdAt)}</span>
      </div>
    </div>
  );
});

FeedbackInfoSection.displayName = 'FeedbackInfoSection';




